import { locales } from "../../../constants/constants";
import { all_percentiles } from "../../../dummy_data/all_percentiles";
import { all_percentiles_spanish } from "../../../dummy_data/all_percentiles_spanish";
export function getPR(params) {
  // TODO: Deprecate when PR service is available
  const {
    score,
    scale,
    grade,
    language,
    window,
  } = params;

  // return null if no score
  if (!score && !(['ARM','Lexile'].includes(scale) && score == 0)) {
    return null;
  }

  const table = getPercentileTable({ scale, grade, language, window });

  // return null if percentiles not found
  if (!table) {
    return null;
  }

  // compute for PR
  let PR = 0;
  for (const percentileScore of table) {
    if (score < percentileScore) {
      break;
    }
    PR++;
  }

  return PR;
};

export function getPercentileValue(params) {
  const { percentile } = params;

  const table = getPercentileTable(params);
  if (!table) return null;

  const index = percentile > 0 ? percentile - 1 : 0;
  return table[index.toString()];
}

function getPercentileTable(params) {
  const {
    scale,
    grade,
    language,
    window,
    useSeasonMap = true,
  } = params;

  // select percentiles for ENGLISH or SPANISH
  const percentiles = language === locales.EN_US ? all_percentiles : all_percentiles_spanish;
  // fetch the percentiles for the season given scale and grade

  // search for "ARM SPANISH SCORES" to find ARM score is determined.
  const scaleId = SCALE_CONSTANTS[scale];
  const gradeId = GRADE_CONSTANTS[grade];
  const seasonId = useSeasonMap ? SEASON_CONSTANTS[window] : window;
  if (!scaleId || !gradeId || !seasonId) return null;
  return percentiles[seasonId][scaleId+gradeId];
}

const SEASON_CONSTANTS = {
  BOY: "fall",
  MOY: "winter",
  EOY: "spring",
};

export const SCALE_CONSTANTS = {
  ARM: "ARM",
  WCPM: "wcpmScore",
  AREA: "areaScore",
  ESRI: "esriScore",
  PSF: "phonAwareScore",
  EVS: "vocabSize",
  Lexile: "Lexile",
  DRA: "DRA",
};

const GRADE_CONSTANTS = {
  "0": "Kindergarden",
  "1": "Firstgrade",
  "2": "Secondgrade",
  "3": "Thirdgrade",
  "4": "Fourthgrade",
  "5": "Fifthgrade",
  "6": "Sixthgrade",
};